import { Field, ScrollableArea } from '@approvalmax/ui';
import styled from 'styled-components';

import ActionsBlock from '../form/ActionsBlock/ActionsBlock';

const sideMargin = '60px';

export const Root = styled.div`
    display: flex;
    flex-flow: column;
    position: relative;
`;

export const CustomFieldsContainer = styled.div`
    display: flex;
    flex-flow: row wrap;
    align-items: flex-end;
`;

export const StyledField = styled(Field)`
    flex: 1;
    min-width: 200px;
    max-width: 200px;
    margin-top: 20px;
    margin-right: 20px;
`;

export const Toolbar = styled.div`
    flex: none;
    padding: 25px 60px 20px;
    border-bottom: 1px solid #cacccd;
`;

export const ToolbarHeader = styled.div`
    display: flex;
`;

export const ToolbarHeaderName = styled.div`
    flex: 1;
    margin-right: 20px;
    display: flex;
    flex-flow: column;
`;

export const ToolbarHeaderActions = styled(ActionsBlock)`
    margin-top: 7px;
`;

export const PremiumBadgeStyled = styled.div`
    align-self: end;
    margin-bottom: 14px;
`;

export const Content = styled(ScrollableArea)`
    flex: 1;
    overflow: hidden;
`;

export const ContentInner = styled.div`
    padding-bottom: 40px;
    display: flex;
    flex-flow: column;
`;

export const EditorContainer = styled.div`
    padding: 20px ${sideMargin};
`;
